import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, Alert, CircularProgress, Button } from '@mui/material';
import api from '../api';
import ElevesTable from './ElevesTable';

export default function ElevesParClasse() {
  const { classeId } = useParams();
  const navigate = useNavigate();
  const [classe, setClasse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');
    if (classeId) {
      api.get(`/classes/${classeId}`)
        .then(res => setClasse(res.data))
        .catch(err => setError(err.response?.data?.error || "Erreur lors du chargement de la classe."))
        .finally(() => setLoading(false));
    }
  }, [classeId]);

  if (loading) return <Box sx={{ mt: 6, textAlign: 'center' }}><CircularProgress /></Box>;
  if (error) return <Alert severity="error" sx={{ m: 4 }}>{error}</Alert>;
  if (!classe) return <Alert severity="warning" sx={{ m: 4 }}>Classe introuvable.</Alert>;

  return (
    <Box sx={{ mt: 4 }}>
      {/* Bouton retour vers la liste des classes */}
      <Box sx={{ mb: 2 }}>
        <Button variant="outlined" onClick={() => navigate('/classes')}>← Retour aux classes</Button>
      </Box>

      <Typography variant="h6" sx={{ mb: 2 }}>
        Élèves de la classe {classe.nom}
      </Typography>
      {/* Utilise ElevesTable pour affichage complet avec QR, suivi, ajout, import, etc */}
      <ElevesTable classe={classe} />
    </Box>
  );
}